import React, {
  useCallback,
  useState,
  useEffect,
  useRef,
  useContext,
} from "react";

import { Link, useHistory } from "react-router-dom";
import { firestore } from "../firebase";

import {
  addDoc,
  arrayUnion,
  collection,
  serverTimestamp,
  updateDoc,
  doc,
  getDocs,
} from "firebase/firestore";

import { ColorModeContext } from "../context/ColorModeProvider";

import useMediaQuery from "@mui/material/useMediaQuery";

import { useUserProvider } from "../context/UserProvider";

import FileDownloadIcon from "@mui/icons-material/FileDownload";

import HeaderDashboard from "./HeaderDashboard";
import Sites from "./Sites";
import AddSite from "./AddSite";

import Loader from "./Loader";

import { Container, CssBaseline, Box, Button, Grid } from "@mui/material";

function PageDashboard() {
  const { theme } = useContext(ColorModeContext);
  const [download, setDownload] = useState([]);
  const downloadLink = useRef();

  const { user } = useUserProvider();

  const downloadMyCollection = async () => {
    const myCollection = collection(firestore, "sites");
    const data = await getDocs(myCollection);
    setDownload(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
  };

  useEffect(() => {
    if (!!download.length) downloadLink.current.click();
  }, [download]);

  const [loading, setLoading] = useState(true);

  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.only("xs"));

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, []);

  return (
    <Container>
      <CssBaseline />
      {loading ? (
        <Loader />
      ) : (
        <>
          <Box sx={{ marginBottom: "3em" }}>
            {/* <AddSite /> */}
            <HeaderDashboard {...user} />
          </Box>
          <Sites />
          {!user ? (
            ""
          ) : (
            <Grid
              align="right"
              // className={
              //   theme.palette.mode === "dark" ? "start_dark" : "start_light"
              // }
              // sx={{
              //   // background: "linear-gradient(45deg, #037FFF 15%, #50E3C2 90%)",
              //   minWidth: "100%",
              //   minHeight: "100vh",
              //   display: "flex",
              //   flexDirection: "column",
              //   justifyContent: "center",
              //   position: "absolute",
              //   top: "0",
              //   left: "0",
              // }}
            >
              <Button
                component="a"
                endIcon={<FileDownloadIcon fontSize="small" />}
                sx={{
                  mt: 2,
                }}
                variant={isSmallScreen ? "contained" : "outlined"}
                size={isSmallScreen ? "large" : "small"}
                className={
                  isSmallScreen ? "downloadButton xsButton" : "downloadButton"
                }
                onClick={downloadMyCollection}
              >
                Export sites data
              </Button>
              <br />
              <a
                href={`data:text/json;charset=utf-8,${encodeURIComponent(
                  JSON.stringify(download)
                )}`}
                download="acoustic_sites.json"
                className="hidden"
                ref={downloadLink}
                style={{ visibility: "hidden" }}
              >
                isHidden
              </a>
            </Grid>
          )}
        </>
      )}
    </Container>
  );
}

export default PageDashboard;
